import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";

export default function NotFound() {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="wrap flex min-h-[70vh] flex-col items-center justify-center py-16 text-center">
        <p className="font-display text-7xl font-bold text-primary-500 md:text-9xl">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-foreground-900">这个瓜田还没开垦</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          页面 <span className="rounded bg-background-100 px-2 py-0.5 font-mono text-foreground-600">{location.pathname}</span>{" "}
          不存在，可能是链接有误或内容已被移除。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" /> 回首页
          </Link>
          <Link
            to="/rank"
            className="flex items-center gap-2 whitespace-nowrap rounded-lg border border-background-200 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-fire-line" aria-hidden="true" /> 去围观热议榜
          </Link>
        </div>
      </main>
    </div>
  );
}